<template>
	<div class="row">
		<div class="col-12">
			<div class="row">
				<div class="col-12">
					<div class="account__block__title">
						{{ t('user.page.table.transactions.title') }}
					</div>
				</div>
			</div>

			<div class="row" v-if="!isSimple">
				<div class="col-12">
					<date-picker
							v-model="date"
							range
							:lang="lang"
							:not-after="new Date()"
							format="DD MMMM YYYY"
							confirm
							:range-separator="'-'"
							class="account__datepicker"
					></date-picker>
				</div>
			</div>
			<div class="table-wrapper">
				<table class="table table-striped account__table account__table--transactions"
					   :class="{ 'loading-blur': storeParams.loading, 'account__table--complex' : !isSimple  }">
					<thead class="thead-dark">
					<tr>
						<th scope="col" v-if="!isSimple">{{ t('user.page.table.transactions.id') }}</th>
						<th scope="col">{{ t('user.page.table.transactions.date') }}</th>
						<th scope="col">{{ t('user.page.table.transactions.type') }}</th>
						<th scope="col">{{ t('user.page.table.transactions.amount') }}</th>
						<th scope="col" v-if="!isSimple">{{ t('user.page.table.transactions.balance') }}</th>
						<th scope="col" v-if="!isSimple">{{ t('user.page.table.transactions.description') }}</th>
					</tr>
					</thead>
					<tbody>
					<tr :key="'transaction'+item.id" v-for="item in transactions">
						<th scope="row" v-if="!isSimple">
							{{item.id}}
						</th>
						<td v-html="dateString(item.created)">

						</td>
						<td v-if="!isSimple">
							{{item.transaction_type_name}}
						</td>
						<td v-if="isSimple">
							{{item.text}}
							<div v-if="isSimple">
								{{item.transaction_type_name}}
							</div>
						</td>
						<td nowrap>
							{{ formatToMoney(item.amount) }}
						</td>
						<td v-if="!isSimple" nowrap>
							{{ formatToMoney(item.balance) }}
						</td>
						<td v-if="!isSimple">
							{{item.text}}
						</td>
					</tr>
					</tbody>
				</table>
			</div>

			<paginate v-if="pageCount && !simple"
					  v-model="params.page_number"
					  :page-count="pageCount"
					  :page-range="3"
					  :margin-pages="2"
					  :prev-text="tPrev"
					  :next-text="tNext"
					  :page-link-class="'page-link'"
					  :container-class="'pagination'"
					  :page-class="'page-item'"
					  :prev-link-class="'page-link'"
					  :prev-class="'page-item'"
					  :next-link-class="'page-link'"
					  :next-class="'page-item'"
			>
			</paginate>
			<div class="row" v-if="pageCount === 0">
				<div class="col-12">
					<div class="jumbotron">
						<h2 class="display-6">{{t('user.page.transactions.no-transactions')}}</h2>
					</div>
				</div>
			</div>
			<div class="row mt-4" v-if="pageCount > 1 && simple">
				<div class="col-12">
					<router-link :to="{name: 'UserTransactions'}" class="btn btn-secondary">{{t('user.page.transactions.showmore')}}</router-link>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Vuex from 'vuex';
	import DatePicker from 'vue2-datepicker';
	import Paginate from 'vuejs-paginate';
	import moment from 'moment-timezone';
	import _ from 'lodash';


	DatePicker.fecha.i18n.monthNames = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

	export default {
		name: 'transaction-table',
		components: {
			DatePicker,
			Paginate
		},
		props: ['simple'],
		data() {
			return {
				test: -500,
				params: {
					//transaction_type: '',
					/*date_from: '',
					date_to: '',*/
					transaction_number: 10,
					page_number	: 1,
				},
				date: [


				],
				page: 1,

				tPrev: '«',
				tNext: '»',



			}
		},
		computed:{
			...Vuex.mapState([
				'lang'
			]),
			...Vuex.mapGetters({
				user: 'getUser',
				userLogedIn: 'getUserStatus'
			}),
			isSimple(){

				return typeof this.simple !== 'undefined'
					?
					this.simple
					:
					false;
			},

			transactions(){
				return this.$store.getters.getTransactions;
			},
			storeParams(){
				return this.$store.getters.getTransactionsParams;
			},
			pageCount(){
				return this.storeParams['total_pages'];
			}
		},
		watch: {
			date: {
				handler(val){

					if(typeof val === 'object' && val.length === 2){
						this.params['date_from'] = moment(val[0]).format('YYYY-MM-DD');
						this.params['date_to'] = moment(val[1]).format('YYYY-MM-DD');
						this.params['page_number'] = 1;
						this.getTransactions();
					}

				},
				deep: true
			},
			'params.page_number': function(){
				this.getTransactions();
			}
		},
		mounted(){
			window.userTrnsTable = this;
			this.params.transaction_number = this.simple ? 7 : 15;

			this.params['date_from'] = '';
			this.params['date_to'] = '';
			this.params['page_number'] = 1;
			this.getTransactions();

		},
		methods:{
			dateString(date){
				date = moment(date);
				let format = this.isSimple ? 'DD/MM' : 'DD/MM/YYYY';

				return `${date.format(format)}
				<br>
				${this.formatToTime(date)}   `;
			},
			getTransactions: _.debounce(() => {
				window.userTrnsTable.$store.commit('setTransactionsParams', window.userTrnsTable.params);
			}, 500)
		}
	}
</script>